/* eslint-disable import/no-anonymous-default-export */
export default {
  auth: {
    login: "/auth/login",
    renewToken: "/auth/renew-token",
    logout: "/auth/sign-out-all-sessions",
    confirmAccount: "/auth/confirm-account",
    changePassword: "/auth/change-password",
    forgotPassword: "/auth/forgot-password",
    resetPassword: "/auth/reset-password",
    meData: "/auth/me",
  },
  itemTypeManagement: {
    add: "/item-type/create-item-type",
    edit: (id) => `/item-type/update-item-type/${id}`,
    getAll: "/item-type/get-item-types",
    getSingle: (id) => `/item-type/get-item-type/${id}`,
    delete: (id) => `/item-type/delete-item-type/${id}`,
  },
  itemSizeManagement: {
    add: "/item-size/create-item-size",
    edit: (id) => `/item-size/update-item-size/${id}`,
    getAll: "/item-size/get-item-sizes",
    getSingle: (id) => `/item-size/get-item-size/${id}`,
    delete: (id) => `/item-size/delete-item-size/${id}`,
  },
  countyManagement: {
    add: "/county/create-county",
    edit: (id) => `/county/update-county/${id}`,
    getAll: "/county/get-counties",
    getSingle: (id) => `/county/get-county/${id}`,
    delete: (id) => `/county/delete-county/${id}`,
  },
  schoolDistrictManagement: {
    add: "/school-district/create-school-district",
    edit: (id) => `/school-district/update-school-district/${id}`,
    getAll: "/school-district/get-school-districts",
    getSingle: (id) => `/school-district/get-school-district/${id}`,
    delete: (id) => `/school-district/delete-school-district/${id}`,
    setSchoolDistrictStatus: (schoolDistrictId) =>
      `/school-district/change-school-district-status/${schoolDistrictId}`,
  },
  schoolManagement: {
    add: "/school/create-school",
    edit: (id) => `/school/update-school/${id}`,
    getAll: "/school/get-schools",
    getSingle: (id) => `/school/get-school/${id}`,
    delete: (id) => `/school/delete-school/${id}`,
  },
  partnerManagement: {
    add: "/affiliate/create-affiliate",
    edit: (id) => `/affiliate/update-affiliate/${id}`,
    getAll: "/affiliate/get-affiliates",
    getSingle: (id) => `/affiliate/get-affiliate/${id}`,
    delete: (id) => `/affiliate/delete-affiliate/${id}`,
    changeAvalaibilityStatus: (partnerId) =>
      `/affiliate/save-availability-status/${partnerId}`,
  },
  formPlaceholderManagement: {
    getAll: `/form-placeholder/get-form-placeholders`,
    getParticularFormPlaceholder: `/form-placeholder/get-form-placeholder/:formPlaceholderId`,
    updateParticularFormPlaceholder: (formPlaceholderId) =>
      `/form-placeholder/update-form-placeholder/${formPlaceholderId}`,
    createFormPlaceholder: `/form-placeholder/create-form-placeholder`,
    delete: (formPlaceholderId) =>
      `/form-placeholder/delete-form-placeholder/${formPlaceholderId}`,
  },
  packetManagement: {
    getAll: `/packet/get-packets`,
    getParticularPacket: (packetId) => `/packet/get-packet/${packetId}`,
    deletePacket: (packetId) => `/packet/delete-packet/${packetId}`,
    updatePacket: (packetId) => `/packet/update-packet/${packetId}`,
    updateGiftCard: (packetId) => `/packet/update-gift-card/${packetId}`,
    updateTotalSpend: (packetId) =>
      `/packet/update-total-spend-amount/${packetId}`,
    acceptPacket: (packetId) => `/packet/accept-packet/${packetId}`,
    rejectPacket: (packetId) => `/packet/reject-packet/${packetId}`,
    shopCompleted: (packetId) => `/packet/shop-completed/${packetId}`,
    deliveredToOffice: (packetId) => `/packet/delivered-to-office/${packetId}`,
    deliveredToStudent: (packetId) =>
      `/packet/delivered-to-student/${packetId}`,
    assignPacket: (packetId) => `/packet/assign-group/${packetId}`,
    getLog: (packetId) => `/packet/get-packet-logs/${packetId}`,
    addComment: "/packet/add-admin-comment",
  },
  volunteer: {
    getAll: "/volunteer/get-volunteers",
    getAvailableVolunteers: (packetId) =>
      `/volunteer/get-available-volunteers/${packetId}`,
    getSingle: (id) => `/volunteer/get-volunteer/${id}`,
    delete: (id) => `/volunteer/delete-volunteer/${id}`,
    assignPacket: (packetId) => `/packet/assign-packet/${packetId}`,
    export: () => `/volunteer/export-volunteers`,
    setBlacklistedStatus: "/volunteer/set-blacklisted-status",
    getLog: (userId) => `/volunteer/get-volunteer-logs/${userId}`,
    addComment: "/volunteer/add-admin-comment",
    addSchoolDistrict: (volunteerId) =>
      `/volunteer/school-district/update-school-district/${volunteerId}`,
  },
  educator: {
    getAll: "/educator/get-educators",
    getSingle: (id) => `educator/get-educator/${id}`,
    delete: (id) => `/educator/delete-educator/${id}`,
    export: () => `/educator/export-educators`,
    setBlacklistedStatus: "/educator/set-blacklisted-status",
  },
  stats: {
    getReports: `/report/get-report`,
    getExportedData: `/report/export-report`,
  },
  subadmin: {
    getAll: `/admin/get-admins`,
    create: `/admin/create-admin`,
    update: (cognitoUserId) => `/admin/update-admin/${cognitoUserId}`,
    delete: (adminId) => `/admin/delete-admin/${adminId}`,
  },
  notifications: {
    getAll: "/notification/get-notifications",
    getSentNotifications: "/notification/get-admin-sent-notifications",
    sendNotification: "/notification/send-notifications-to-user-types",
  },
  partner: {
    getAll: "/partner/get-partners",
  },
  groupManagement: {
    add: "/group/create-group",
    edit: (id) => `/group/update-group/${id}`,
    getAll: "/group/get-groups",
    getSingle: (id) => `/group/get-group/${id}`,
    delete: (id) => `/group/delete-group/${id}`,
    changeAvalaibilityStatus: (partnerId) =>
      `/group/save-availability-status/${partnerId}`,
    getAvailableGroups: (packetId) => `/group/get-available-groups/${packetId}`,
  },
};
